'use strict';
// tslint:disable
/**
 * Multimedia Server Api
 * Мультимедиа сервер апи
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    return function (d, b) {
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
    };
  })();
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.MmserverApi = exports.MmserverApiFactory = exports.MmserverApiFp = exports.MmserverApiAxiosParamCreator = exports.ErrorType = void 0;
var qs = require('qs');
var globalImportUrl = require('url');
var axios_1 = require('axios');
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require('./base');
/**
 * FORM_ERROR - needs to display global message in a custom container, not in modal. Normally it`s not connected to any field. It has the same meaning as MESSAGE but shows in a custom container. MESSAGE - needs to display in a toats window VALIDATION_ERROR - needs to display under the connected field, it`s a model validation error ERROR_CODE - needs to create a custom behavior UNKNOWN - needs to show common error for unknow error type
 * @export
 * @enum {string}
 */
var ErrorType;
(function (ErrorType) {
  ErrorType['FORMERROR'] = 'FORM_ERROR';
  ErrorType['UNKNOWN'] = 'UNKNOWN';
  ErrorType['MESSAGE'] = 'MESSAGE';
  ErrorType['ERRORCODE'] = 'ERROR_CODE';
  ErrorType['VALIDATIONERROR'] = 'VALIDATION_ERROR';
})((ErrorType = exports.ErrorType || (exports.ErrorType = {})));
/**
 * MmserverApi - axios parameter creator
 * @export
 */
exports.MmserverApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Переносит документы в постоянное хранилище
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyDocuments: function (requestBody, options) {
      if (options === void 0) {
        options = {};
      }
      var localVarPath = '/applyDocuments';
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        var accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = accessToken && 'Bearer ' + accessToken;
      }
      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(
        __assign(__assign({}, localVarUrlObj.query), localVarQueryParameter),
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __assign(
        __assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions),
        options.headers,
      );
      var needsSerialization =
        typeof requestBody !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(requestBody !== undefined ? requestBody : {})
        : requestBody || '';
      var queryString = qs.stringify(localVarUrlObj.query);
      queryString = queryString ? '?' + queryString : '';
      delete localVarUrlObj.query;
      var url = globalImportUrl.format(localVarUrlObj);
      return {
        url: url + queryString,
        options: localVarRequestOptions,
      };
    },
    /**
     * Получение документа по его идентификатору
     * @param {string} documentId уникальный идентификатор документа
     * @param {number} [quality] качество сжатия 0 - без сжатия 1 2 3 - максимальное сжатие
     * @param {boolean} [rotate] повернуть по часовой на 90 градусов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument: function (documentId, quality, rotate, options) {
      if (options === void 0) {
        options = {};
      }
      // verify required parameter 'documentId' is not null or undefined
      if (documentId === null || documentId === undefined) {
        throw new base_1.RequiredError(
          'documentId',
          'Required parameter documentId was null or undefined when calling getDocument.',
        );
      }
      var localVarPath = '/getDocument/{documentId}'.replace(
        '{' + 'documentId' + '}',
        encodeURIComponent(String(documentId)),
      );
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        var accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = accessToken && 'Bearer ' + accessToken;
      }
      if (quality !== undefined) {
        localVarQueryParameter['quality'] = quality;
      }
      if (rotate !== undefined) {
        localVarQueryParameter['rotate'] = rotate;
      }
      localVarUrlObj.query = __assign(
        __assign(__assign({}, localVarUrlObj.query), localVarQueryParameter),
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __assign(
        __assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions),
        options.headers,
      );
      var queryString = qs.stringify(localVarUrlObj.query);
      queryString = queryString ? '?' + queryString : '';
      delete localVarUrlObj.query;
      var url = globalImportUrl.format(localVarUrlObj);
      return {
        url: url + queryString,
        options: localVarRequestOptions,
      };
    },
    /**
     * Удаляет документ по id
     * @param {string} documentId уникальный идентификатор документа
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDocument: function (documentId, options) {
      if (options === void 0) {
        options = {};
      }
      // verify required parameter 'documentId' is not null or undefined
      if (documentId === null || documentId === undefined) {
        throw new base_1.RequiredError(
          'documentId',
          'Required parameter documentId was null or undefined when calling removeDocument.',
        );
      }
      var localVarPath = '/removeDocument/{documentId}'.replace(
        '{' + 'documentId' + '}',
        encodeURIComponent(String(documentId)),
      );
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      // authentication bearerAuth required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        var accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = accessToken && 'Bearer ' + accessToken;
      }
      localVarUrlObj.query = __assign(
        __assign(__assign({}, localVarUrlObj.query), localVarQueryParameter),
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __assign(
        __assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions),
        options.headers,
      );
      var queryString = qs.stringify(localVarUrlObj.query);
      queryString = queryString ? '?' + queryString : '';
      delete localVarUrlObj.query;
      var url = globalImportUrl.format(localVarUrlObj);
      return {
        url: url + queryString,
        options: localVarRequestOptions,
      };
    },
    /**
     * Загрузить документ на мультимедиа сервер
     * @param {any} [file] document file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadDocument: function (file, options) {
      if (options === void 0) {
        options = {};
      }
      var localVarPath = '/uploadDocument';
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData();
      // authentication bearerAuth required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        var accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = accessToken && 'Bearer ' + accessToken;
      }
      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(
        __assign(__assign({}, localVarUrlObj.query), localVarQueryParameter),
        options.query,
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __assign(
        __assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions),
        options.headers,
      );
      localVarRequestOptions.data = localVarFormParams;
      var queryString = qs.stringify(localVarUrlObj.query);
      queryString = queryString ? '?' + queryString : '';
      delete localVarUrlObj.query;
      var url = globalImportUrl.format(localVarUrlObj);
      return {
        url: url + queryString,
        options: localVarRequestOptions,
      };
    },
  };
};
/**
 * MmserverApi - functional programming interface
 * @export
 */
exports.MmserverApiFp = function (configuration) {
  return {
    /**
     * Переносит документы в постоянное хранилище
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyDocuments: function (requestBody, options) {
      var localVarAxiosArgs = exports
        .MmserverApiAxiosParamCreator(configuration)
        .applyDocuments(requestBody, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }
        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }
        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url,
        });
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Получение документа по его идентификатору
     * @param {string} documentId уникальный идентификатор документа
     * @param {number} [quality] качество сжатия 0 - без сжатия 1 2 3 - максимальное сжатие
     * @param {boolean} [rotate] повернуть по часовой на 90 градусов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument: function (documentId, quality, rotate, options) {
      var localVarAxiosArgs = exports
        .MmserverApiAxiosParamCreator(configuration)
        .getDocument(documentId, quality, rotate, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }
        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }
        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url,
        });
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Удаляет документ по id
     * @param {string} documentId уникальный идентификатор документа
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDocument: function (documentId, options) {
      var localVarAxiosArgs = exports
        .MmserverApiAxiosParamCreator(configuration)
        .removeDocument(documentId, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }
        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }
        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url,
        });
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Загрузить документ на мультимедиа сервер
     * @param {any} [file] document file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadDocument: function (file, options) {
      var localVarAxiosArgs = exports
        .MmserverApiAxiosParamCreator(configuration)
        .uploadDocument(file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }
        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }
        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url,
        });
        return axios.request(axiosRequestArgs);
      };
    },
  };
};
/**
 * MmserverApi - factory interface
 * @export
 */
exports.MmserverApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Переносит документы в постоянное хранилище
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyDocuments: function (requestBody, options) {
      return exports.MmserverApiFp(configuration).applyDocuments(requestBody, options)(
        axios,
        basePath,
      );
    },
    /**
     * Получение документа по его идентификатору
     * @param {string} documentId уникальный идентификатор документа
     * @param {number} [quality] качество сжатия 0 - без сжатия 1 2 3 - максимальное сжатие
     * @param {boolean} [rotate] повернуть по часовой на 90 градусов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument: function (documentId, quality, rotate, options) {
      return exports.MmserverApiFp(configuration).getDocument(documentId, quality, rotate, options)(
        axios,
        basePath,
      );
    },
    /**
     * Удаляет документ по id
     * @param {string} documentId уникальный идентификатор документа
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDocument: function (documentId, options) {
      return exports.MmserverApiFp(configuration).removeDocument(documentId, options)(
        axios,
        basePath,
      );
    },
    /**
     * Загрузить документ на мультимедиа сервер
     * @param {any} [file] document file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadDocument: function (file, options) {
      return exports.MmserverApiFp(configuration).uploadDocument(file, options)(axios, basePath);
    },
  };
};
/**
 * MmserverApi - object-oriented interface
 * @export
 * @class MmserverApi
 * @extends {BaseAPI}
 */
var MmserverApi = /** @class */ (function (_super) {
  __extends(MmserverApi, _super);
  function MmserverApi() {
    return (_super !== null && _super.apply(this, arguments)) || this;
  }
  /**
   * Переносит документы в постоянное хранилище
   * @param {Array<string>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MmserverApi
   */
  MmserverApi.prototype.applyDocuments = function (requestBody, options) {
    return exports.MmserverApiFp(this.configuration).applyDocuments(requestBody, options)(
      this.axios,
      this.basePath,
    );
  };
  /**
   * Получение документа по его идентификатору
   * @param {string} documentId уникальный идентификатор документа
   * @param {number} [quality] качество сжатия 0 - без сжатия 1 2 3 - максимальное сжатие
   * @param {boolean} [rotate] повернуть по часовой на 90 градусов
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MmserverApi
   */
  MmserverApi.prototype.getDocument = function (documentId, quality, rotate, options) {
    return exports
      .MmserverApiFp(this.configuration)
      .getDocument(
        documentId,
        quality,
        rotate,
        options,
      )(this.axios, this.basePath);
  };
  /**
   * Удаляет документ по id
   * @param {string} documentId уникальный идентификатор документа
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MmserverApi
   */
  MmserverApi.prototype.removeDocument = function (documentId, options) {
    return exports.MmserverApiFp(this.configuration).removeDocument(documentId, options)(
      this.axios,
      this.basePath,
    );
  };
  /**
   * Загрузить документ на мультимедиа сервер
   * @param {any} [file] document file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MmserverApi
   */
  MmserverApi.prototype.uploadDocument = function (file, options) {
    return exports.MmserverApiFp(this.configuration).uploadDocument(file, options)(
      this.axios,
      this.basePath,
    );
  };
  return MmserverApi;
})(base_1.BaseAPI);
exports.MmserverApi = MmserverApi;
